import {useState} from 'react'

import Style from './style'
import ChangeTimerModal from './ui/ChangeTimerModal'

import MainHeader from 'widget/MainHeader'

import useGetEventDetail from 'entity/event/useGetEventDetail'
import usePostEventInit from 'entity/event/usePostEventInit'

import useEventInfor from 'entity/event/useEventInfor'
import useSupabaseRealtime from 'entity/event/useSupabaseRealtime'
import useIsMobile from 'shared/model/useIsMobile'
import ITStyle from 'shared/style/inputTableStyle'
import ConnectionStatus from 'shared/ui/ConnectionStatus'
import DefaultButton from 'shared/ui/DefaultButton'
import EventInfor from 'shared/ui/EventInfor'
import SupabaseConnectError from 'shared/ui/SupabaseConntectError'
import {
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
	ROLE_TIMER_MANAGER,
} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'
import usePostEventOpen from 'entity/event/usePostEventOpen'
import {
	END,
	PAUSE,
	READY,
	REGISTER,
	TAKING,
} from 'shared/constant/lookup/eventState'
import usePostEventClose from 'entity/event/usePostEventClose'
import usePostEventPause from 'entity/event/usePostEventPause'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import usePostEventStart from 'entity/event/usePostEventStart'
import {useParams} from 'react-router-dom'

const EventTimerParticipant = () => {
	const isMobile = useIsMobile()
	const [userRole] = useRoleCookie()
	const [timerSelect, setTimerSelect] = useState(false)
	const [startRegister] = usePostEventOpen()
	const [eventData, , eventDataLoading] = useGetEventDetail()
	const [pauseEvent] = usePostEventPause()
	const [initEvent] = usePostEventInit()
	const [closeEvent] = usePostEventClose()
	const [startEvent] = usePostEventStart()
	const [, setModalEvent] = useConfirmModalAtom()
	const {idx} = useParams()
	const isTimerManager = userRole === ROLE_TIMER_MANAGER
	// 백엔드 데이터 매핑용 State
	const {infoData, success, setInfoData} = useEventInfor(eventData)
	const {
		timeData,
		isLoading,
		countDown,
		supabaseConnectError,
		supabaseConnectErrorStatus,
	} = useSupabaseRealtime(success, setInfoData, eventData)
	const split = countDown ? countDown?.split(':') : ['00', '00']
	const isWarning = split[0] === '00' && parseInt(split[1]) <= 10 ? true : false

	const btnList = []

	// 관리자 라면 추가
	if (![ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER].includes(userRole)) {
		btnList.push({
			label: '접수 시작',
			clickEvent: () =>
				setModalEvent(
					'플레이어들이 대회에 신청 & 참가를 할 수 있게 됩니다.\n접수를 시작하시겠습니까?',
					() => startRegister
				),
			deactive: eventData?.data?.event_state_flag !== READY,
		})
	}

	;[
		{
			label: '대회 시작',
			clickEvent: () =>
				setModalEvent(
					'대회가 시작되면 돌릴 수 없습니다.\n대회를 시작하시겠습니까?',
					() => startEvent
				),
			deactive: eventData?.data?.event_state_flag !== REGISTER,
		},
		{
			label:
				eventData?.data?.event_state_flag === PAUSE
					? '재시작'
					: '대회 일시 정지',
			clickEvent: () => pauseEvent(),
			deactive: [READY, REGISTER, END].includes(
				eventData?.data?.event_state_flag
			),
		},
		{
			label: '대회 종료',
			clickEvent: () =>
				setModalEvent(
					'대회가 종료되면 점수가 반영되며 돌릴 수 없습니다.\n대회를 종료하시겠습니까?',
					() => closeEvent
				),
			deactive: eventData?.data?.event_state_flag !== TAKING,
		},
		{
			label: 'QR 출력',
			clickEvent: () =>
				window.open(`/event/${idx}/qr`, '_blank', 'noopener,noreferrer'),
		},
	].forEach((elem) => btnList.push(elem))

	return (
		<>
			<Style.Wrapper>
				<ConnectionStatus />

				<MainHeader
					mobileLayout='eventParticipant'
					title={eventDataLoading ? '...' : eventData?.data?.name}
					btnList={isTimerManager ? btnList : []}
				/>

				<EventInfor
					level={timeData?.level || 'N/A'}
					time={countDown || '00:00'}
					players={infoData[0].data}
					entries={infoData[1].data}
					reEntry={infoData[2].data}
					early={infoData[3].data}
					addOn={infoData[4].data}
					avgStackBB={infoData[5].data}
					totalStack={infoData[6].data}
					isLoading={isLoading}
					isWarning={isWarning}
					isMobile={isMobile}
					initEvent={() => initEvent()}
					setTimerSelect={() => setTimerSelect(true)}
				/>

				<Style.SubHeaderContainer>
					<ITStyle.TableDivEvenParticipant
						$showEarly={eventData?.data?.early_end_level != null}
					>
						<ITStyle.TableVerticalElementEvenParticipant
							$isTimer
							$isMobile={isMobile}
						>
							<ITStyle.Timer>타이머</ITStyle.Timer>
							<ITStyle.BtnDefaultContainer>
								<DefaultButton fitWidth small clickEvent={() => initEvent()}>
									타이머 초기화
								</DefaultButton>
								<DefaultButton
									fitWidth
									small
									clickEvent={() => setTimerSelect(true)}
								>
									타이머 특정 레벨로 이동
								</DefaultButton>
							</ITStyle.BtnDefaultContainer>
						</ITStyle.TableVerticalElementEvenParticipant>
					</ITStyle.TableDivEvenParticipant>
				</Style.SubHeaderContainer>
			</Style.Wrapper>

			{timerSelect && (
				<ChangeTimerModal closeEvent={() => setTimerSelect(false)} />
			)}
			{supabaseConnectError && (
				<SupabaseConnectError
					isVisible={supabaseConnectError}
					status={supabaseConnectErrorStatus}
				/>
			)}
		</>
	)
}

export default EventTimerParticipant
